const siteSwitcher = document.querySelectorAll(".site-switcher");
siteSwitcher &&
  siteSwitcher.forEach(s => {
    s.addEventListener("change", e => {
      console.log("click", e);
    });
  });
